import { render, staticRenderFns } from "./67.vue?vue&type=template&id=0398e69a&scoped=true&"
var script = {}
import style0 from "./67.vue?vue&type=style&index=0&id=0398e69a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0398e69a",
  null
  
)

export default component.exports